<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [selectionVisible]="false"
      [idField]="'id'"
      [data]="data"
      (itemClick)="onItemClick($event)"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 5%">
          {{ 'ID' | translate }}
        </th>
        <td mat-cell *matCellDef="let sequence">{{ sequence.id }}</td>
      </ng-container>

      <ng-container matColumnDef="template">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 5%">
          {{ 'context.template' | translate }}
        </th>
        <td mat-cell *matCellDef="let sequence">{{ sequence.template }}</td>
      </ng-container>

      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%">
          {{ 'Scope' | translate }}
        </th>
        <td mat-cell *matCellDef="let sequence">{{ sequence.primaryCounterSpec.scope }}</td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
